import React from 'react';
import Engagement from './pages/Engagement';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import SetNewPassword from './pages/SetNewPassword';
import Support from './pages/Support';
import RequestDemo from './pages/RequestDemo';
import Dashboard from './pages/Dashboard';
import { PreviewAndSend } from 'components/PreviewAndSend';
import Shop from './pages/Shop';
import Purchase from './pages/Purchase';
import PanelRecommendation from './pages/ChoosePanel';
import { Router } from 'react-router-dom';
import SurveyBuilder from 'pages/SurveyBuilder';
import NewSurveyOptions from 'pages/NewSurveyOptions';
import { SurveyContextProvider } from 'contexts/SurveyContext';
import RouterWrapper from './router/RouterWrapper';
import { history } from './helpers/router';
import Results from 'pages/Results';
import UserContextProvider from './contexts/UserContext';
import { PrivateRoute } from 'router/PrivateRoute';
import { PublicRoute } from 'router/PublicRoute';
import PanelRecommendationContextProvider from './contexts/PanelRecommendationContext';
import ErrorContextProvider from '@ax2/common/contexts/ErrorContext';
import TermsAndConditions from 'pages/TermsAndConditions';
import { BrowserChecker } from '@ax2/common/components/BrowserChecker';
import { LaunchSurvey } from 'components/LaunchSurvey';
import Metrics from 'pages/Metrics';
import UserManagement from 'pages/UserManagement';

const App: React.FC = () => {
  return (
    <BrowserChecker>
      <UserContextProvider>
        <ErrorContextProvider>
          <SurveyContextProvider>
            <PanelRecommendationContextProvider>
              <RouterWrapper>
                <Router history={history}>
                  <PublicRoute exact path="/" component={Engagement} />
                  <PublicRoute path="/signIn" component={SignIn} />
                  <PublicRoute path="/signUp" component={SignUp} />
                  <PublicRoute
                    path="/forgotPassword"
                    component={ForgotPassword}
                  />
                  <PublicRoute
                    path="/setNewPassword"
                    component={SetNewPassword}
                  />
                  <PublicRoute path="/support" component={Support} />
                  <PublicRoute path="/requestDemo" component={RequestDemo} />
                  <PublicRoute path="/shop" component={Shop} />

                  <PublicRoute
                    path="/choosePanel"
                    component={PanelRecommendation}
                  />
                  <PublicRoute
                    path="/termsAndConditions"
                    component={TermsAndConditions}
                  />
                  <PrivateRoute path="/purchase" component={Purchase} />
                  <PrivateRoute path="/dashboard" component={Dashboard} />
                  <PrivateRoute path="/metrics" component={Metrics} />
                  <PrivateRoute
                    path="/user-management"
                    component={UserManagement}
                  />
                  <PrivateRoute path="/P&S" component={PreviewAndSend} />
                  <PrivateRoute path="/PS" component={LaunchSurvey} />

                  <PrivateRoute
                    path="/newSurveyOptions/:newSurveyType"
                    component={NewSurveyOptions}
                  />
                  <PrivateRoute
                    path="/surveyBuilder/:editSurveyType"
                    component={SurveyBuilder}
                  />
                  <PrivateRoute path="/results" component={Results} />
                </Router>
              </RouterWrapper>
            </PanelRecommendationContextProvider>
          </SurveyContextProvider>
        </ErrorContextProvider>
      </UserContextProvider>
    </BrowserChecker>
  );
};

export default App;
